/**
 * DevExtreme (ui/themes_callback.js)
 * Version: 18.2.4
 * Build date: Mon Dec 17 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var Callbacks = require("../core/utils/callbacks");
module.exports = new Callbacks;



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/devextreme/ui/themes_callback.js
// module id = ../../../../devextreme/ui/themes_callback.js
// module chunks = common